import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { handleSSOLoginAction } from '../../store/auth/actions.js';
import { getCookie } from '../../commonUtils/cookie.helper.js';
import { getDefaultPageByRole } from '../../commonUtils/authUtils.js';
import { setCookie } from '../../commonUtils/cookie.helper.js';
import constants from '../../commonUtils/constants.js';
import { encrypt } from '../../commonUtils/crypto.helper.js';

const SSORedirectHandler = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const auth_local = getCookie("authToken");
  const isAuthorized = ( auth_local );

  useEffect(() => {
    const handleSSORedirect = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const status = urlParams.get('status');
        let payload = { data: {}, navigate };
        
        if (status === "success") {
            const token = urlParams.get('token');
            const user = urlParams.get('user');
            const authMode = urlParams.get('authMode');
            const refreshToken = urlParams.get('refreshToken');
            const refreshTokenExpires = urlParams.get('refreshTokenExpires');
            
            let userData = null;
            try {
                if (user) {
                    userData = JSON.parse(decodeURIComponent(user));
                }
            } catch (err) {
                console.error("Failed to parse SSO user data", err);
            }
            
            // Handle token storage based on authMode
            if (authMode === "header" && refreshToken) {
                sessionStorage.setItem("refreshToken", decodeURIComponent(refreshToken));
                sessionStorage.setItem("refreshTokenExpires", decodeURIComponent(refreshTokenExpires));
            }
            
            // Set auth token cookie and user data (same as regular login)
            const authTokenExpiration = Date.now() + constants.auth.accessTokenExpiryIntervalDuration;
            setCookie('authToken', token, constants.auth.refreshTokenDuration);
            setCookie('authTokenExpiration', authTokenExpiration, constants.auth.refreshTokenDuration);
            
            if (userData) {
                const encryptedUserData = encrypt(JSON.stringify(userData));
                setCookie('_u0_', encryptedUserData, constants.auth.refreshTokenDuration);
            }
            
            payload.data.success = true;
            payload.data.data = { 
                token, 
                user: userData,
                authMode: authMode || 'cookie'
            };

        } else {
            const msg = urlParams.get('msg');
            payload.data.success = false;
            payload.data.data = { message: msg || "Internal Server Error", navigate };
        }
        
        dispatch(handleSSOLoginAction(payload));
    };

    handleSSORedirect();
  }, [dispatch, navigate]);

  useEffect(() => {
      if(isAuthorized){
          getDefaultPageByRole(navigate);
      }
  }, [isAuthorized, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <p className="mt-4 text-gray-600">Processing SSO login...</p>
      </div>
    </div>
  );
};

export default SSORedirectHandler;